import { useCallback, useState } from "react";

export default function useMemorize(name) {
  const getStorage = useCallback(
    () => window.localStorage.getItem(name),
    [name]
  );
  const setStorage = useCallback(
    (value) => window.localStorage.setItem(name, value),
    [name]
  );
  const [memo, setMemo] = useState(getStorage() || name);

  const setMemoAndStorage = useCallback((value) => {
    setMemo(value);
    setStorage(value);
  });

  return [memo, setMemoAndStorage];
}
